import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { getManagerAndTherapist, getSingleUser } from '../Services/Users';

const UserDetail = () => {
    const { id } = useParams();
    const [userData, setUserData] = useState()
    console.log(userData);
    const [otherData, setOtherData] = useState()
    console.log(otherData);
    // get data api

    const getSingleApiFunc = async () => {
        const userResp = await getSingleUser(id);
        if (userResp.status === 200) {
            setUserData(userResp?.data?.data);
            // checking of role is inhouse 
            if (userResp?.data?.data?.role === "InHouse") {
                const resp = await getManagerAndTherapist(id)
                setOtherData(resp?.data?.data);
            }
        } else {
            alert("User is Blocked.UnBlock the User to View Detail")
        }
    }
    useEffect(() => {
        getSingleApiFunc()
    }, [])

    return (
        <div>
            <div className="mainDashboard side_dashboard_container">
                <div className="row">
                    <div className="col-md-12">
                        <Link to="/manage-user" className="dashboardHeading arrowbefore">
                            <img src="/assets/images/Icon ionic-ios-arrow-back.svg" alt="" />
                            <h2>User Details</h2>
                        </Link>
                    </div>
                </div>
                <div className="users-table set3">
                    <div className="users-table-container set-5">
                        <div className="user-table-head setUD">
                            <div className="userHeading setUserDeatils">
                                <img
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = "/assets/images/user Detail Image1.png";
                                    }}
                                    className="imgSeting"
                                    src={userData?.profilePicture} alt="" />
                                <div className='detailCtn'>
                                    <h4>Full Name</h4>
                                    <h3>{userData?.fullName}</h3>
                                </div>
                            </div>
                        </div>
                        <div className="therapist_detail setUserDetails setFinalUserDetails" style={{ flexWrap: "wrap" }}>
                            <div className="therapist_list">
                                <h3>Email</h3>
                                <p>{userData?.email}</p>
                            </div>
                            <div className="therapist_list">
                                <h3>Phone Number</h3>
                                <p>{userData?.phoneNumber}</p>
                            </div>
                            <div className="therapist_list">
                                <h3>Assessment Day</h3>
                                <p>{userData?.assessmentDay}</p>
                            </div>
                            <div className="therapist_list">
                                <h3>Sober Day</h3>
                                <p>{userData?.soberDay}</p>
                            </div>
                            {/* <div className="userDetailSec">
                            
                            </div> */}
                        </div>
                    </div>
                </div>

                {userData?.role === "InHouse" &&
                    <div className="users-table-container users-table">
                        <h2 style={{ color: "#fff", fontSize: "18px" }}>Therapist Details</h2>
                        <div className="therapist_detail setWd19" style={{ marginTop: "1px" }}>
                            <div className="therapist_list">
                                <h3>Name</h3>
                                <p>{otherData?.therapistName}</p>
                            </div>
                            <div className="therapist_list">
                                <h3>Email</h3>
                                <p>{otherData?.therapistEmail}</p>
                            </div>
                            <div className="therapist_list">
                                {/* <h3>Phone Number</h3>
                            <p>{userData?.phoneNumber}</p> */}
                            </div>
                            <div className="therapist_list">
                                {/* <h3>Phone Number</h3>
                            <p>{userData?.phoneNumber}</p> */}
                            </div>
                        </div>

                        <h2
                            style={{ color: "#fff", fontSize: "18px", marginTop: "22px", borderTop: "1px solid #EBF2F733", paddingTop: "17px" }}
                        >
                            Case Manager Details
                        </h2>
                        <div className="therapist_detail setWd19" style={{ marginTop: "1px" }}>
                            <div className="therapist_list">
                                <h3>Name</h3>
                                <p>{otherData?.caseManagerName}</p>
                            </div>
                            <div className="therapist_list">
                                <h3>Email</h3>
                                <p>{otherData?.caseManagerEmail}</p>
                            </div>
                            <div className="therapist_list">
                                {/* <h3>Phone Number</h3>
                                <p>{userData?.phoneNumber}</p> */}
                            </div>
                            <div className="therapist_list">
                                {/* <h3>Phone Number</h3>
                                <p>{userData?.phoneNumber}</p> */}
                            </div>
                        </div>
                    </div>

                }
            </div>
        </div>
    );
}

export default UserDetail;